import { Project } from 'src/api/model/project';
import { RequestBuilder } from 'src/api/common/request-builder';
import { ProjectSearchForm } from 'src/api/model/search/project-search-form';
import { Pagable } from 'src/constants/pagable';
import { RequestUtils } from 'src/utils/request-utils';
import { ProjectForm } from 'src/api/model/form/project-form';
import { ProjectData } from '../model/response/project-data';
import { ProjectValueForm } from '../model/form/project-value-form';
import { Page } from '../common/page';
import { CategoryData } from '../model/response/category-data';
import { CountProjectSearchForm } from '../model/search/count-project-search-form';
import { ProjectSettingForm } from '../model/form/project-setting-form';
import { ProjectEditForm } from '../model/project-edit-form';
import { ProjectExportFilterForm } from '../model/search/project-export-filter-form';
import { CustomPagable } from 'src/constants/custom-pagable';

export class ProjectApi {
  findAll(
    form: ProjectSearchForm,
    pagable: Pagable,
  ): Promise<Project[]> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<Project>()
      .url('/work/project')
      .config({ params: params })
      .findAll();
  }

  getAll(): Promise<Project[]> {
    return new RequestBuilder<Project>()
      .url('/work/project/getAll')
      .findAll();
  }

  getProjects(
    form: ProjectSearchForm,
  ): Promise<CategoryData[]> {
    return new RequestBuilder<CategoryData>()
      .url('/work/project/getProjects')
      .config({ params: form })
      .findAll();
  }

  getDataPagging(
    form: ProjectSearchForm,
    pagable: Pagable,
  ): Promise<Page<Project>> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<Project>()
      .url('/work/project/getDataPagging')
      .config({ params: params })
      .findAllPagging();
  }

  getDataExportExcel(
    form: ProjectExportFilterForm,
    pagable: CustomPagable,
  ): Promise<Page<Project>> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<Project>()
      .url('/work/project/getDataPagging')
      .config({ params: params })
      .findAllPagging();
  }

  countByUser(
    form: CountProjectSearchForm,
  ): Promise<number> {
    return new RequestBuilder<number>()
      .url('/work/project/countByUser')
      .config({ params: form })
      .get();
  }

  countByDept(id: string | number): Promise<number> {
    return new RequestBuilder<number>()
      .url(`/work/project/countByDept?id=${id}`)
      .get();
  }

  findById(id: string): Promise<Project> {
    return new RequestBuilder<Project>()
      .url(`/work/project/${id}`)
      .findOne();
  }

  save(form: ProjectForm) {
    return new RequestBuilder<Project>()
      .url('/work/project')
      .data(form)
      .post();
  }

  update(id: string, form: ProjectForm) {
    return new RequestBuilder<Project>()
      .url(`/work/project/${id}`)
      .data(form)
      .put();
  }

  updateWithReason(id: string, form: ProjectEditForm) {
    return new RequestBuilder<Project>()
      .url(`/work/project/update/${id}`)
      .data(form)
      .put();
  }

  delete(id: string) {
    return new RequestBuilder<Project>()
      .url(`/work/project/${id}`)
      .delete();
  }

  changeValue(id: string, form: ProjectValueForm) {
    return new RequestBuilder<Project>()
      .url(`/work/project/${id}/changeColumnValue`)
      .data(form)
      .post();
  }

  changeSetting(id: string, form: ProjectSettingForm) {
    return new RequestBuilder<Project>()
      .url(`/work/project/${id}/changeSetting`)
      .data(form)
      .post();
  }

  exportExcel(form: any) {
    return new RequestBuilder<any>()
      .url(`/work/task/export-tasks-by-projects`)
      .data(form)
      .config({
        responseType: 'blob',
      })
      .post();
  }

  bindFollowers(projectId: string) {
    return new RequestBuilder<any>()
      .url(
        `work/project-follower/${projectId}/find-all-by-project`,
      )
      .get();
  }

  getListFilterProjects() {
    return new RequestBuilder<any>()
      .url(`report/progress/filter-projects`)
      .get();
  }
}

export const projectApi = new ProjectApi();
